import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteSkillCategoryMutation($input: DeleteSkillCategoryInput!) {
		deleteSkillCategory(input: $input) {
			deletedSkillCategoryId
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.companyId,
			connectionKeys: [
				{
					key: 'Company_skillCategories',
				},
			],
			pathToConnection: ['company', 'skillCategories'],
			deletedIDFieldName: 'deletedSkillCategoryId',
		},
		{
			type: 'NODE_DELETE',
			deletedIDFieldName: 'deletedSkillCategoryId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteSkillCategory: {
			deletedSkillCategoryId: input.id,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Skill Category Deleted');

	const cleanedInput = omit(input, ['companyId']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
